import {Box, Button, Flex, useDisclosure} from '@chakra-ui/react'
import {useTranslation} from 'next-i18next'
import {useState} from 'react'
import {Modal} from '_app/components'
import {ApplePay as ApplePayIcon, CloseIcon} from '_app/components/Icons'
import LoadEasyPack from '_app/components/LoadEasyPack'
import {ShippingMethod} from './ShippingMethod'
import {useAppleSession} from './useAppleSession'

type Props = {
    buttonClickCallback?: () => Promise<void>;
    modalCloseCallback?: () => void;
    displayButtonInColumn?: boolean;
};

export const ApplePay = ({
                             buttonClickCallback,
                             modalCloseCallback,
                             displayButtonInColumn = false,
                         }: Props) => {
    const {t} = useTranslation('cart')
    const {isOpen, onOpen, onClose} = useDisclosure()
    const [validForm, setValidForm] = useState(false)
    const {startAppleSession} = useAppleSession({modalCloseCallback})

    const handleMainButtonClick = async () => {
        if (buttonClickCallback) {
            await buttonClickCallback()
        }

        onOpen()
    }

    const handleModalClose = () => {
        if (modalCloseCallback) {
            modalCloseCallback()
        }

        onClose()
    }

    return (
        <>
            <LoadEasyPack/>
            <Flex flexDirection="column">
                <Button
                    mt={displayButtonInColumn ? 3 : {base: 3, md: 'unset'}}
                    width={displayButtonInColumn ? 'full' : {base: 'full', md: '19rem'}}
                    variant="outline"
                    onClick={handleMainButtonClick}
                >
                    {t('PAY_WITH_APPLE_PAY', {ns: 'common'})}
                </Button>

                <Modal
                    isOpen={isOpen}
                    onClose={handleModalClose}
                    position="relative"
                    maxWidth="500px"
                    overflow="visible"
                >
                    <CloseIcon
                        position="absolute"
                        top="16px"
                        right="16px"
                        cursor="pointer"
                        onClick={handleModalClose}
                    />

                    <Box m="1.5rem">
                        <ShippingMethod setValidForm={setValidForm}/>

                        <Button
                            width="full"
                            variant="outline"
                            mt="2rem"
                            isDisabled={!validForm}
                            onClick={startAppleSession}
                        >
                            <ApplePayIcon/>
                        </Button>
                    </Box>
                </Modal>
            </Flex>
        </>
    )
}
